import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CoverageIcon } from "@/components/benefits/v2/typeIcons";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

export type VoluntaryRFPParameters = {
  selectedBenefits: string[];
};

type VoluntaryRFPFormProps = {
  value: VoluntaryRFPParameters;
  onChange: (value: VoluntaryRFPParameters) => void;
};

const VOLUNTARY_BENEFITS = [
  { id: 'accident', label: 'Accident Insurance' },
  { id: 'critical_illness', label: 'Critical Illness Insurance' },
  { id: 'cancer', label: 'Cancer Insurance' },
  { id: 'hospital_indemnity', label: 'Hospital Indemnity' },
  { id: 'gap', label: 'Gap Insurance' },
  { id: 'pet', label: 'Pet Insurance' },
  { id: 'legal', label: 'Legal Services' },
  { id: 'identity_theft', label: 'Identity Theft Protection' },
  { id: 'whole_life', label: 'Whole Life Insurance' },
  { id: 'universal_life', label: 'Universal Life Insurance' },
];

export function VoluntaryRFPForm({ value, onChange }: VoluntaryRFPFormProps) {
  const updateField = (field: keyof VoluntaryRFPParameters, newValue: any) => {
    onChange({ ...value, [field]: newValue });
  };

  const toggleBenefit = (benefitId: string) => {
    const current = value.selectedBenefits || [];
    const updated = current.includes(benefitId)
      ? current.filter(b => b !== benefitId)
      : [...current, benefitId];
    updateField('selectedBenefits', updated);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <CoverageIcon planType="accident" size="sm" />
          Voluntary
        </CardTitle>
        <p className="text-xs text-muted-foreground">Employee-paid extras to quote alongside the main lines.</p>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-3">
          <Label>Select Voluntary Worksite Benefits to Include in RFP</Label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {VOLUNTARY_BENEFITS.map((benefit) => (
              <div key={benefit.id} className="flex items-center space-x-2">
                <Checkbox
                  id={`voluntary-${benefit.id}`}
                  checked={value.selectedBenefits?.includes(benefit.id)}
                  onCheckedChange={() => toggleBenefit(benefit.id)}
                />
                <label 
                  htmlFor={`voluntary-${benefit.id}`} 
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  {benefit.label}
                </label>
              </div>
            ))}
          </div>
        </div>

      </CardContent>
    </Card>
  );
}
